export type TJurisdiction = {
  id: string;
  name: string;
};
export type TCity = {
  id: string;
  name: string;
  jurisdictions: TJurisdiction[];
};
export type TProvince = {
  id: string;
  name: string;
  cities: TCity[];
};
export type TSubscriberWaterMeter = {
  id: string;
  waterMeterId: string;
  serialNo: string;
  installationDT: string;
  unInstallationDT: string;
};
export type TWaterSubscriber = {
  id: string;
  apartmentId: string;
  floorNo: number;
  unitNo: string;
  identifierId: string;
  subscriberName: string;
  nationalId: string;
  phoneNumber: string;
  mobileNumber: string;
  postalCode: string;
  email: string;
  // waterMeterId?: string;
  installationDT?: string;
  currentWaterMeter?: TSubscriberWaterMeter;
  historicalWaterMeters?: TSubscriberWaterMeter[];
  readingData: TWaterMeterReadingData;
};
export type TApartment = {
  id: string;
  address: string;
  identifierId: string;
  numberOfFloor: number;
  latitude: number;
  longitude: number;
  waterSubscribers: TWaterSubscriber[];
  jurisdictionId: string;
  apartmentType: ApartmentType;
};
export enum WaterMeterType {
  ColdWater = 1,
  HotWater = 2,
}
export enum WaterMeterLocationType {
  Wherehouse = 1,
  Installed = 2,
  Retired = 3,
}
export enum WaterMeterModelType {
  None = 0,
  BMeter = 1,
  PulseDetector = 2,
}
export enum WaterMeterCommunicationType {
  LORA = 1,
  GPRS = 2,
  NBIOT = 3,
  RF = 4,
}
export enum WaterMeterAuthType {
  OTAA = 1,
  ABP = 2,
}
export enum WaterMeterAlarmsType {
  // None = 0,
  // Leakage = 1 << 0, // 0x0001
  // Burst = 1 << 1, // 0x0002
  // Backflow = 1 << 2, // 0x0004
  // Tamper = 1 << 3, // 0x0008
  // ReverseFlow = 1 << 4, // 0x0010
  // EmptyPipe = 1 << 5, // 0x0020
  // TemperatureAlarm = 1 << 6, // 0x0040
  // BatteryLow = 1 << 7, // 0x0080
  // SensorError = 1 << 8, // 0x0100
  // CommunicationError = 1 << 9, // 0x0200
  // RtcError = 1 << 10, // 0x0400
  // ConfigurationError = 1 << 11, // 0x0800
  None = 0,
  Tamper = 1,
  Riservato1 = 4,
  Riservato2 = 8,
  WrongInst = 16,
  EmptyPipe = 32,
  Freezing = 64,
  Qmax = 128,
  WaterLoss = 256,
  Burst = 512,
  ReverseFlow = 1024,
  NoConsumption = 2048,
  Reset = 4096,
  ExcessiveTemp = 8192,
  Riservato3 = 16384,
  Battery = 32768,
  NFCFraud = 65536,
  RTC = 131072,
}

export type TWaterMeterConfig = {
  id: string;
  communicationType: WaterMeterCommunicationType;
  authType: WaterMeterAuthType;
  encryptionkey: string;
  // Only for OTTA
  devEUI: string;
  appEUI: string;
  loraAppKey: string;
  // Only for ABP
  loraAppSKey: string;
  loraDeviceAddress: string;
  loraNetworkKey: string;
};
export type TWaterMeterReadingDataRecord = {
  dt: Date;
  reportedUsage: number;
  dayUsage: number;
  batteryPercentage: number;
  alarms: WaterMeterAlarmsType;
};
export type TWaterMeterReadingData = {
  id: string;
  waterMeterId: string;
  totalUsageInPeriod: number;
  latestAlarm: WaterMeterAlarmsType;
  allAlarms: number;
  readingData: TWaterMeterReadingDataRecord[] | [];
};
export type TWaterMeterInstallation = {
  waterSubscriberId: string;
  address: string;
  apartmentId: string;
  floorNo: number;
  unitNo: string;
  identifierId: string;
  installationDT: string;
  unInstallationDT: string;
  latitude: number;
  longitude: number;
};
export type TWaterMeter = {
  id: string;
  serialNo: string;
  productionYear: number;
  waterMeterType: WaterMeterType;
  locationType: WaterMeterLocationType;
  modelType: WaterMeterModelType;
  // province: TProvince;
  provinceId: string;
  // city: TCity;
  cityId: string;
  // jurisdiction: TJurisdiction;
  jurisdictionId: string;
  config: TWaterMeterConfig;
  currentInstallation?: TWaterMeterInstallation;
  installationHistory: TWaterMeterInstallation[];
  readingData: TWaterMeterReadingData;
  lastSyncDT: string;
  batteryPercentage: number;
  lastReading: number;
  lastAlarm?: WaterMeterAlarmsType;
  isDeleted?: boolean;
};
export type TWaterMeter_LazyLoad = TWaterMeter & {
  // Fields returned by the GetWaterMeters lazy-load list (optional here since the
  // full single-meter GetWaterMeter response may omit them).
  activityStatus?: WaterMeterActivityStatus;
  isInstalled?: boolean;
  installation?: TWaterMeterInstallationInfo;
};

// Active-installation summary carried on the GetWaterMeters lazy-load rows.
// Null on the backend when the meter is not installed.
export type TWaterMeterInstallationInfo = {
  waterSubscriberId: string;
  subscriberName?: string;
  identifierId?: string;
  floorNo: number;
  unitNo?: string;
  address?: string;
  installationDate: string;
};

export enum WaterMeterActivityStatus {
  // Meter has never reported any sync data.
  NeverSeen = 1,
  // Last sync happened within the activity window (last 3 days).
  Active = 2,
  // Meter has reported before, but not within the activity window.
  NotActive = 3,
}

export type TUser = {
  id: string;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  provinceId: string;
  cityId: string;
  jurisdictionId: string;
  userType: UserType;
  roles: TRole[];
};
export enum UserType {
  Admin = 1,
  Province = 2,
  City = 3,
  Jurisdiction = 4,
}

export type TRole = {
  id: string;
  name: string;
};

export enum WaterSubscriberType {
  Private = 1,
  Commercial = 2,
  Governmental = 3,
}

// Active installed-meter summary carried on the GetWaterSubscribers lazy-load rows.
// Null on the backend when the subscriber has no installed meter.
export type TSubscriberWaterMeterInfo = {
  waterMeterId: string;
  serialNo?: string;
  modelType: WaterMeterModelType;
  locationType: WaterMeterLocationType;
  installationDate: string;
  lastSyncDT: string;
  lastReading: number;
  batteryPercentage: number;
  activityStatus: WaterMeterActivityStatus;
};

export type TWaterSubscriber_LazyLoad = TWaterSubscriber & {
  address?: string;
  subscriberType?: WaterSubscriberType;
  hasInstalledWaterMeter?: boolean;
  installedWaterMeter?: TSubscriberWaterMeterInfo;
};

type TWaterUsage = {
  usage: number;
  waterMeterId: string;
  waterSubscriberId: string;
  identifierId: string;
  latitude: number;
  longitude: number;
};

type TWaterMeterWithErrors = TWaterUsage & {
  latestAlarmOnWm: WaterMeterAlarmsType;
};

export type TOverviewReport = {
  totalWaterUsage: number;
  topNWaterUsage: TWaterUsage[];
  waterMeterWithErrors: TWaterMeterWithErrors[];
};

export enum ApartmentType {
  Apartment = 1,
  Complex = 2,
  Villa = 3,
  Commercial = 4,
}
